import NiceModal from "@ebay/nice-modal-react";
import CommonModal from "../CommonModal";
import CommonButton from "../../common/commonButton/CommonButton";
import OKXImg from "../../../assets/images/okx.png";
import TomoImg from "../../../assets/images/icon3.png";
import XverseImg from "../../../assets/images/xverse.png";
import BitgetImg from "../../../assets/images/bitget.png";
import "./ConnectBtcWalletModal.scss";
const ConnectBtcWalletModal = NiceModal.create(
  ({ closeConnectWalletModal, handleConnect }: any) => {
    const list = [
      {
        title: "OKX Wallet",
        img: OKXImg,
        id: "okx"
      },
      {
        title: "Xverse Wallet",
        img: XverseImg,
        id: "xverse"
      },
      {
        title: "Tomo Wallet",
        img: TomoImg,
        id: "tomo"
      },
      {
        title: "Bitget Wallet",
        img: BitgetImg,
        id: "bitget"
      },
    ];
    return (
      <CommonModal
        className="connectBtcWalletModal"
        show
        onHide={closeConnectWalletModal}
        heading="Connect to a BTC wallet"
      >
        <div className="connectwalletmodal_list">
          <ul>
            {list.map((item: any, index: number) => (
              <li key={index}>
                <CommonButton
                  title={item.title}
                  imgicon={item.img}
                  onClick={() => handleConnect(item.id)}
                  className="full connectwalletmodal_list_btn"
                />
              </li>
            ))}
          </ul>
        </div>
      </CommonModal>
    );
  }
);

export default ConnectBtcWalletModal;
